export default (name, meta) => {
	window.Intercom("trackEvent", name, meta);
};



// WEBPACK FOOTER //
// ./src/utils/event-tracker.js